import type { Product } from '../types/product'

export const products: Product[] = [
  {
    id: 'carne',
    name: 'Empanada de Carne',
    category: 'Carne',
    description: 'Chile dulce, cebolla, aceituna, huevo y ajo.',
    price: '₡1.500',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/3fa5d663-83b9-4fd3-845e-1639a8f9fbe4.jpg',
  },
  {
    id: 'pollo',
    name: 'Empanada de Pollo',
    category: 'Pollo',
    description: 'Chile dulce, cebolla, aceituna, huevo y ajo.',
    price: '₡1.500',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bdfdb021-3b4e-41f2-9c81-93a007bef919.jpg',
  },
  {
    id: 'caprese',
    name: 'Empanada de Caprese',
    category: 'Caprese',
    description: 'Albahaca, queso y tomate.',
    price: '₡1.500',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e4052a59-55d1-4adc-8aa6-3ada3c9c396f.jpg',
  },
  {
    id: 'jamon-y-queso',
    name: 'Empanada de Jamón y Queso',
    category: 'Jamón y Queso',
    description: 'El clásico de siempre, bien cargado.',
    price: '₡1.500',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/86011fcb-ae6e-4d33-be9b-751421f5d499.jpg',
  },
  {
    id: 'vegetales',
    name: 'Empanada de Vegetales',
    category: 'Vegetales',
    description: 'Calabacín, berenjena, zanahoria y chile dulce.',
    price: '₡1.500',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8e8a2ec2-1bff-49ac-bc63-f3d10241ff66.jpg',
  },
  {
    id: 'cebolla-caramelizada',
    name: 'Empanada de Cebolla Caramelizada',
    category: 'Cebolla Caramelizada',
    description: 'Con miel, mostaza Dijon y queso.',
    price: '₡1.500',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d34e67c6-9e67-4638-ab4d-c491854fb1aa.jpg',
  },
  {
    id: 'pescado-finas-hierbas',
    name: 'Empanada de Pescado a las Finas Hierbas',
    category: 'Pescado a las Finas Hierbas',
    description: 'Tilapia, cebolla morada, tomate cherry y limón.',
    price: '₡1.900',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4a46b7bf-a28a-4768-b6c9-d929243d0f8d.jpg',
    premium: true,
  },
  {
    id: 'cerdo-dulce',
    name: 'Empanada de Cerdo Dulce',
    category: 'Cerdo Dulce',
    description: 'Manzana verde, mostaza y miel.',
    price: '₡1.900',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/99c1b347-a59d-41e8-89cb-bc7cad89fd85.jpg',
    premium: true,
  },
]
